// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1___84447056d0264fe6e5d","cls2":"AuthorHeader-cls2__e0f23384c133f6f8c543 AuthorHeader-cls1___84447056d0264fe6e5d"};